/**
 * Equivalente de OnBeforeInternalNavigation de NavigationLock: los editores con cambios sin guardar se registran aquí y
 * la navegación sin recarga entre pantallas migradas (useEnhancedNavigation) les pregunta antes de salir. Cada guarda
 * responde si se puede salir; si muestra su propia ventana de descartar, responde cuando la persona decide.
 */
export type LeaveGuard = () => boolean | Promise<boolean>;

const guards = new Set<LeaveGuard>();

/** Registra una guarda mientras el editor está en pantalla; devuelve la función que la quita. */
export function registerLeaveGuard(guard: LeaveGuard): () => void {
  guards.add(guard);
  return () => {
    guards.delete(guard);
  };
}

/** Sin guardas no hay nada que preguntar: la navegación sigue en el mismo clic. */
export function hasLeaveGuards(): boolean {
  return guards.size > 0;
}

/** Pregunta a cada guarda en orden; la primera que no deja salir detiene la navegación. */
export async function confirmLeave(): Promise<boolean> {
  for (const guard of [...guards]) if (!(await guard())) return false;
  return true;
}
